import { BUFFERED_ACTIONS } from './input-frame';
import type { BufferedAction, InputFrame } from './input-frame';

export interface BufferedInputEntry {
  readonly sequence: number;
  readonly action: BufferedAction;
  age: number;
}

export class ActionInputBuffer {
  private entries: BufferedInputEntry[];
  private nextSequence: number;

  public constructor(entries: readonly BufferedInputEntry[] = [], nextSequence = 0) {
    this.entries = entries.map((entry) => ({ ...entry }));
    this.nextSequence = nextSequence;
  }

  public beginFrame(current: InputFrame, previous: InputFrame): void {
    this.entries = this.entries.filter((entry) => entry.age < 6);
    for (const action of BUFFERED_ACTIONS) {
      if (current[action] && !previous[action]) {
        this.entries.push({ action, age: 0, sequence: this.nextSequence });
        this.nextSequence += 1;
      }
    }
  }

  public getCandidates(): readonly Readonly<BufferedInputEntry>[] {
    return this.entries.map((entry) => Object.freeze({ ...entry }));
  }

  public consume(sequence: number): boolean {
    const index = this.entries.findIndex((entry) => entry.sequence === sequence);
    if (index < 0) return false;
    this.entries.splice(index, 1);
    return true;
  }

  public endFrame(): void {
    for (const entry of this.entries) entry.age += 1;
  }

  public clear(): void {
    this.entries = [];
  }

  public clone(): ActionInputBuffer {
    return new ActionInputBuffer(this.entries, this.nextSequence);
  }

  public get size(): number {
    return this.entries.length;
  }
}
